import React, { useEffect } from 'react';

import SectionMessage from '@atlaskit/section-message';

import { bugsnagNotify } from 'src/lib/bugsnag';
import { errorsToObject } from 'src/lib/error';

const SectionMessageStyled = ({ body, ...rest }) => {
  const texts = (body || '').split('\n');
  return (
    <div data-cy="error-message"><SectionMessage {...rest}>
      {texts.map((t, i) => <div key={i}>{t}</div>)}
    </SectionMessage></div>
  );
};

const ErrorMessage = ({ error, appearance, ...rest }) => {
  appearance = appearance || 'error';

  useEffect(() => {
    if (appearance === 'error') {
      bugsnagNotify(error);
    }
  }, [error, appearance]);

  return <SectionMessageStyled {...errorsToObject(error)} appearance={appearance} {...rest}/>;
};
export default ErrorMessage;
